import styled from '@emotion/styled';
import Error from '@material-ui/icons/Error';
import { createElement, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

const RequiredLabel = () => (
  <>
    <StyledErrorIcon color="error" />
    <IsRequiredMessage>
      <FormattedMessage id="project_basic_setting_detail.assets.required" />
    </IsRequiredMessage>
  </>
);

const StyledErrorIcon = styled(Error)`
  width: 18px;
  height: 18px;
  vertical-align: top;
`;

const IsRequiredMessage = styled.span`
  color: #f18179;
  font-size: 14px;
  vertical-align: top;
  font-weight: bold;
`;

export default RequiredLabel;
